export const YSTNJ_DOMAIN_ROUTER_CACHE_RETENTION_SECONDS = 10 * 60;
